import React, { useState, useEffect } from "react"

import { connect } from "react-redux"
import {
  addUserFile,
  deleteUserFile,
  filterExecutor,
  filterExecutorLoading,
  getListExecutor,
  getUserFiles,
  inactiveExecutor,
  upsertExecutor,
} from "store/actions"
import { columns } from "./columns"
import {
  Table,
  Input,
  Space,
  Button,
  Row,
  Col,
  Form,
  InputNumber,
  Checkbox,
  Radio,
  Select,
  Card,
  Modal,
  Typography,
} from "antd"
import { PersianDatePickerInline } from "components/Common/PersianDatePickerInline"
import Locations from "components/Common/Locations"
import { withTranslation } from "react-i18next"
import {
  PlusOutlined,
  DownloadOutlined,
  ReloadOutlined,
  UserOutlined,
  IdcardOutlined,
  PhoneOutlined,
  BankOutlined,
  SafetyCertificateOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  SaveOutlined,
  CloseOutlined,
  EditOutlined,
} from "@ant-design/icons"

const { Title, Text } = Typography

const ExecutorList = props => {
  const {
    lstExecutor,
    onGetListExecutor,
    onFilterLoading,
    onFilterExecutor,
    loading,
    onUpsertExecutor,
    openNotification,
  } = props
  const [executorForm] = Form.useForm()
  const [editingId, setEditingId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)

  const [errorMessage, setErrorMessage] = useState(null)
  const [filterAddress, setFilterAddress] = useState(0)
  const [solarMembershipDate, setSolarMembershipDate] = useState("")
  const [solarWorkPermitDateOfIssue, setSolarWorkPermitDateOfIssue] =
    useState("")
  const [solarLicenseExpire, setSolarLicenseExpire] = useState("")
  const [fullName, setFullName] = useState("")
  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null)
    }, 3000)
  }, [errorMessage])

  useEffect(() => {
    onGetListExecutor()
  }, [])

  useEffect(async () => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
  }, [props.success, props.error])

  useEffect(() => {
    if (!editingId) {
      onFilterLoading(true)
      const timeout = setTimeout(() => {
        onFilterExecutor({
          fullName,
          idSection: dataAddress.sectionId,
          filterAddress,
        })
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [fullName, dataAddress, filterAddress])

  const onChangeFullName = e => {
    setFullName(e.target.value)
  }
  const handleSubmit = values => {
    setModalLoading(true)
    let updatedData = {
      ...values,
      solarMembershipDate: solarMembershipDate.persian,
      solarWorkPermitDateOfIssue: solarWorkPermitDateOfIssue.persian,
      solarLicenseExpire: solarLicenseExpire.persian,
      idSection: +dataAddress.sectionId,
      id: editingId,
    }
    onUpsertExecutor(updatedData)

    if (editingId) {
      // setData(updatedData)
      setEditingId(null)
    }
    executorForm.resetFields()
    setTimeout(() => {
      setModalLoading(false)
      setIsModalOpen(false)
    }, 300)
  }

  const handleEdit = record => {
    executorForm.setFieldsValue(record)
    // setSolarBirthDate(record.solarBirthDate)
    setEditingId(record.id)
    setIsModalOpen(true)
  }

  const handleOpenCreate = () => {
    executorForm.resetFields()
    setEditingId(null)
    setSolarMembershipDate("")
    setSolarWorkPermitDateOfIssue("")
    setSolarLicenseExpire("")
    setDataAddress({
      sectionId: 0,
      fullAddress: {
        pro: "",
        cit: "",
        sec: "",
        lat: 35.311308,
        lng: 46.991271,
        mainAddress: "",
      },
    })
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setEditingId(null)
    executorForm.resetFields()
  }

  const handleResetFilters = () => {
    setFullName("")
    setFilterAddress(0)
    onGetListExecutor()
  }
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra)
  }
  return (
    <>
      {/* Header Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
          padding: "20px",
          borderRadius: "12px",
          marginBottom: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <h2
              style={{
                color: "white",
                margin: 0,
                fontSize: "24px",
                fontWeight: "600",
              }}
            >
              مدیریت مجریان
            </h2>
            <p
              style={{
                color: "rgba(255,255,255,0.8)",
                margin: "4px 0 0 0",
                fontSize: "14px",
              }}
            >
              ایجاد، ویرایش و مدیریت اطلاعات مجریان
            </p>
          </Col>
          <Col>
            <Space>
              <Button
                type="primary"
                size="large"
                icon={<PlusOutlined />}
                onClick={handleOpenCreate}
                style={{
                  background: "rgba(255,255,255,0.2)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "8px",
                  color: "white",
                  fontWeight: "500",
                }}
              >
                افزودن مجری
              </Button>
              <Button
                size="large"
                icon={<DownloadOutlined />}
                disabled
                style={{
                  background: "rgba(255,255,255,0.2)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "8px",
                  color: "white",
                  fontWeight: "500",
                  opacity: 0.6,
                  cursor: "not-allowed",
                }}
              >
                خروجی اکسل
              </Button>
            </Space>
          </Col>
        </Row>
      </div>

      {/* Filter Section */}
      <Card
        style={{
          marginBottom: "16px",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          border: "1px solid #e8e8e8",
        }}
        bodyStyle={{ padding: "16px 24px" }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={12} md={8} lg={6}>
            <Input
              prefix={<span style={{ color: "#bfbfbf" }}>👤</span>}
              placeholder="جستجو بر اساس نام..."
              value={fullName}
              onChange={onChangeFullName}
              size="large"
              style={{ borderRadius: "8px" }}
              allowClear
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Locations
              setDataAddress={setDataAddress}
              matches_sm={true}
              idSection={executorForm.getFieldValue("idSection")}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Radio.Group
              onChange={e => setFilterAddress(e.target.value)}
              value={filterAddress}
              buttonStyle="solid"
            >
              <Radio.Button value={0}>استان</Radio.Button>
              <Radio.Button value={1}>شهرستان</Radio.Button>
              <Radio.Button value={2}>بخش</Radio.Button>
            </Radio.Group>
          </Col>
          <Col>
            <Button
              icon={<ReloadOutlined />}
              onClick={handleResetFilters}
              style={{ borderRadius: "8px" }}
            >
              ریست فیلتر
            </Button>
          </Col>
        </Row>
      </Card>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: "16px",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "12px",
                background: editingId
                  ? "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)"
                  : "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            >
              {editingId ? (
                <EditOutlined style={{ fontSize: "24px", color: "white" }} />
              ) : (
                <PlusOutlined style={{ fontSize: "24px", color: "white" }} />
              )}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: "#1f2937" }}>
                {editingId ? "ویرایش مجری" : "افزودن مجری جدید"}
              </Title>
              <Text type="secondary" style={{ fontSize: "13px" }}>
                {editingId
                  ? "اطلاعات مجری را ویرایش کنید"
                  : "اطلاعات مجری جدید را وارد کنید"}
              </Text>
            </div>
          </div>
        }
        open={isModalOpen}
        onCancel={handleCloseModal}
        width={900}
        centered
        destroyOnClose
        footer={null}
        style={{ top: 20 }}
        styles={{
          body: {
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
            padding: "0 24px 24px",
          },
        }}
      >
        <Form
          name="engForm"
          form={executorForm}
          onFinish={handleSubmit}
          layout="vertical"
          requiredMark="optional"
        >
          <Card
            type="inner"
            title={
              <Space>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background:
                      "linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <UserOutlined style={{ color: "#1890ff", fontSize: "16px" }} />
                </div>
                <Text strong style={{ fontSize: "15px" }}>
                  اطلاعات مجری
                </Text>
              </Space>
            }
            style={{ marginBottom: "16px", borderRadius: "12px", border: "1px solid #e8e8e8" }}
            headStyle={{ background: "#fafafa", borderRadius: "12px 12px 0 0" }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  required
                  tooltip="نام اجباریست"
                  label="نام و نام خانوادگی/نام شرکت"
                  name="fullName"
                  onChange={onChangeFullName}
                  rules={[{ required: true, message: "نام را وارد کنید" }]}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
                    placeholder="نام کامل"
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  required
                  label="کد ملی"
                  name="naCode"
                  rules={[{ required: true, message: "کد ملی را وارد کنید" }]}
                >
                  <InputNumber
                    prefix={<IdcardOutlined style={{ color: "#bfbfbf" }} />}
                    style={{ width: "100%", borderRadius: "8px" }}
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12}>
                <Form.Item required label="موبایل" name="cellPhone">
                  <Input
                    prefix={<PhoneOutlined style={{ color: "#bfbfbf" }} />}
                    placeholder="09XXXXXXXXX"
                    maxLength={11}
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item label="شماره پروانه" name="licenseNumber">
                  <Input
                    prefix={<SafetyCertificateOutlined style={{ color: "#bfbfbf" }} />}
                    placeholder="شماره پروانه"
                    size="large"
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card
            type="inner"
            title={
              <Space>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background:
                      "linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <BankOutlined style={{ color: "#52c41a", fontSize: "16px" }} />
                </div>
                <Text strong style={{ fontSize: "15px" }}>مالکیت و مجوز</Text>
              </Space>
            }
            style={{ marginBottom: "16px", borderRadius: "12px", border: "1px solid #e8e8e8" }}
            headStyle={{ background: "#fafafa", borderRadius: "12px 12px 0 0" }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="دارای پروانه"
                  name="license"
                  valuePropName="checked"
                >
                  <Checkbox>دارای پروانه</Checkbox>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="نوع مالکیت"
                  name="ownershipTypeEnum"
                  rules={[{ required: true, message: "نباید خالی باشد" }]}
                >
                  <Select placeholder="نوع مالکیت" size="large">
                    <Select.Option value={1}>حقیقی</Select.Option>
                    <Select.Option value={2}>حقوقی</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="رسته"
                  name="executorTypeEnum"
                  rules={[{ required: true, message: "نباید خالی باشد" }]}
                >
                  <Select placeholder="نوع رسته مجری" size="large">
                    <Select.Option value={1}>حرفه ای</Select.Option>
                    <Select.Option value={2}>تجربی</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="حیطه کاری"
                  name="executorGradTypeEnum"
                  rules={[{ required: true, message: "نباید خالی باشد" }]}
                >
                  <Select placeholder="نوع حیطه کاری مجری" size="large">
                    <Select.Option value={1}>خانگی</Select.Option>
                    <Select.Option value={2}>صنعتی</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="تاریخ اخذ پروانه"
                  name="julianWorkPermitDateOfIssue"
                >
                  <PersianDatePickerInline
                    defaultDate={executorForm
                      .getFieldValue("julianWorkPermitDateOfIssue")
                      ?.toString()
                      ?.substring(0, 10)}
                    setPersianDate={setSolarWorkPermitDateOfIssue}
                    isPortal
                    zIndex={4000}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  label="تاریخ اعتبار پروانه"
                  name="julianLicenseExpire"
                >
                  <PersianDatePickerInline
                    defaultDate={executorForm
                      .getFieldValue("julianLicenseExpire")
                      ?.toString()
                      ?.substring(0, 10)}
                    setPersianDate={setSolarLicenseExpire}
                    isPortal
                    zIndex={4000}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card
            type="inner"
            title={
              <Space>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background:
                      "linear-gradient(135deg, #fffbe6 0%, #ffe58f 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <EnvironmentOutlined style={{ color: "#faad14", fontSize: "16px" }} />
                </div>
                <Text strong style={{ fontSize: "15px" }}>اطلاعات مکانی</Text>
              </Space>
            }
            style={{ marginBottom: "16px", borderRadius: "12px", border: "1px solid #e8e8e8" }}
            headStyle={{ background: "#fafafa", borderRadius: "12px 12px 0 0" }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12}>
                <Form.Item label="استان" name="idSection">
                  <Locations
                    setDataAddress={setDataAddress}
                    matches_sm={true}
                    idSection={executorForm.getFieldValue("idSection")}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card
            type="inner"
            title={
              <Space>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background:
                      "linear-gradient(135deg, #f9f0ff 0%, #d3adf7 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CalendarOutlined style={{ color: "#722ed1", fontSize: "16px" }} />
                </div>
                <Text strong style={{ fontSize: "15px" }}>تاریخ‌ها</Text>
              </Space>
            }
            style={{ marginBottom: "16px", borderRadius: "12px", border: "1px solid #e8e8e8" }}
            headStyle={{ background: "#fafafa", borderRadius: "12px 12px 0 0" }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="تاریخ عضویت" name="julianMembershipDate">
                  <PersianDatePickerInline
                    defaultDate={executorForm
                      .getFieldValue("julianMembershipDate")
                      ?.toString()
                      ?.substring(0, 10)}
                    setPersianDate={setSolarMembershipDate}
                    isPortal
                    zIndex={4000}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              paddingTop: "16px",
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <Button
              size="large"
              icon={<CloseOutlined />}
              onClick={handleCloseModal}
              style={{ borderRadius: "8px", minWidth: "120px" }}
            >
              انصراف
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={modalLoading}
              icon={editingId ? <SaveOutlined /> : <PlusOutlined />}
              style={{
                borderRadius: "8px",
                minWidth: "140px",
                background: editingId
                  ? "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)"
                  : "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            >
              {editingId ? "ذخیره تغییرات" : "افزودن مجری"}
            </Button>
          </div>
        </Form>
      </Modal>

      <Table
        loading={loading}
        size="middle"
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        scroll={{
          y: 600,
          x: 900,
        }}
        sticky
        columns={columns({ props, handleEdit })}
        rowClassName={(_r, i) => (i % 2 ? "odd" : "even")}
        rowKey={record => record.id}
        dataSource={lstExecutor}
        onChange={onChange}
        style={{
          borderRadius: "12px",
          overflow: "hidden",
        }}
      />
    </>
  )
}

const mapStateToProps = ({ Executors, USERs }) => ({
  lstExecutor: Executors.lstExecutor,
  error: Executors.error,
  success: Executors.success,
  loading: Executors.loading,
  lstUserFiles: USERs.lstUserFiles,
  errorUser: USERs.error,
  successUser: USERs.success,
})

const mapDispatchToProps = dispatch => ({
  onGetListExecutor: () => dispatch(getListExecutor()),
  onInactiveExecutor: exeId => dispatch(inactiveExecutor(exeId)),
  onFilterExecutor: data => dispatch(filterExecutor(data)),
  onFilterLoading: data => dispatch(filterExecutorLoading(data)),
  onAddUserFile: attachData => dispatch(addUserFile(attachData)),
  onDeleteUserFile: id => dispatch(deleteUserFile(id)),
  onGetUserFiles: searchValue => dispatch(getUserFiles(searchValue)),
  onUpsertExecutor: data => dispatch(upsertExecutor(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ExecutorList))
